import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { routing } from './app.routing';

import {
  FooterComponent, HeaderComponent,
  HeaderService, ContactComponent, ConfirmOrderComponent, GridComponent,
  AuthenticationComponent, TermsConditionsComponent, NotificationAlertComponent,
  AlertBannerComponent, AlertModalComponent,
  ErrorPageComponent, LoginModalComponent,AbmFaciliateEnrollmentComponent
} from './pages';

import { PageLoaderService, BreadCrumbService, TimeOutPopupService } from './ui-components';


import {
  ErrorComponent, RestrictedUserComponent, PageNotFoundComponent, SupportComponent
} from 'lib/ng2-sapmp/src/pages';

import {
  AuthenticationService, UtilityService, HttpClientService,
  UserWizardService, AdobeAnalyticsService
} from 'lib/ng2-sapmp/src/providers';

import { NavigationToBlockGuard } from './pages/initial-signup/navigationBlock.guard';
import {
  CoreLibModule, GridLibModule, ModalLibModule, PaginationLibModule
} from 'lib/ng2-sapmp/src/modules';

import { SystemErrorComponent } from './pages/system-error/system-error.component';

import { SystemMaintenanceComponent } from './pages/system-maintenance/system-maintenance.component';

import { CMSResolver } from 'lib/ng2-sapmp/src/providers/cms.resolver';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { CMSModule, LoginModule } from 'environments/environment';
import { UserProfileGuard } from 'lib/ng2-sapmp/src/guards/user-profile.guard';
import { MultiStubIdProfileGuard } from 'lib/ng2-sapmp/src/guards/multistubid-profile.guard';
import { AdminGuard } from 'lib/ng2-sapmp/src/guards/admin.guard';
import { EfotaCustomerComponent } from './pages/efota-customer/efota-customer.component';
import { ChipsComponent } from 'lib/ng2-sapmp/src/ui-components/chips/chips.component';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
import { BlockNavigationGuard } from './pages/product-selection/blockNavigation.guard';
import { FaqAccessGuard } from './pages/faq/faq-access.guard';
import { ReviewpocComponent } from './pages/signup-setup/reviewpoc/reviewpoc.component';
import { EnrollmentpocComponent } from './pages/signup-setup/enrollmentpoc/enrollmentpoc.component';
import { MenusComponent } from './pages/menus/menus.component';
import { MultiStubidPageComponent } from './pages/multi-stubid-page/multi-stubid-page.component';
import { FivegPrivateRoutingGuard } from 'lib/ng2-sapmp/src/guards/learn5G.guard';
import { CustomHeaderComponent } from './pages/care/custom-header/custom-header.component';

// import { StoreRouterConnectingModule } from '@ngrx/router-store';

@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authReq = req.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                 Pragma: 'no-cache'
            }
        });
        return next.handle(authReq);    
    }
}

@NgModule({
  declarations: [
    AppComponent,
    AuthenticationComponent,
    TermsConditionsComponent,
    NotificationAlertComponent,
    AlertBannerComponent,
    SystemErrorComponent,
    SystemMaintenanceComponent,
    // scrum team 2 components
    SupportComponent,
    ContactComponent,
    PageNotFoundComponent,
    ErrorPageComponent,
    ErrorComponent,
    AbmFaciliateEnrollmentComponent,

    /* SupportComponent,
    FaqComponent, */
    GridComponent,
    RestrictedUserComponent,
    ConfirmOrderComponent,
    AlertModalComponent,
    HeaderComponent,
    FooterComponent,
    ChipsComponent,
    LoginModalComponent,
    EfotaCustomerComponent,
    MenusComponent,
    MultiStubidPageComponent,
    CustomHeaderComponent,
  ],

  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    routing,
    // for components present in app module
    CMSModule,
    LoginModule,
    CoreLibModule,
    ModalLibModule,
    GridLibModule,
    PaginationLibModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: false })
    // StoreRouterConnectingModule.forRoot({stateKey: 'router'})
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [DatePipe, CMSResolver, UserProfileGuard, AdminGuard,
    AuthenticationService, HttpClientService, UtilityService, ChipsService,
    PageLoaderService, TimeOutPopupService, UserWizardService, BreadCrumbService, 
    AdobeAnalyticsService, HeaderService, NavigationToBlockGuard, BlockNavigationGuard, MultiStubIdProfileGuard, FivegPrivateRoutingGuard,
    FaqAccessGuard
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: NoCacheHeadersInterceptor,
    //   multi: true
    // }
  ],
  bootstrap: [AppComponent],
  // entryComponents: [NotificationAlertComponent]
})
export class AppModule { }
